import script from "./SubscriptionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionTable.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionTable.vue?vue&type=style&index=0&id=002c3c6a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002c3c6a"]])

export default __exports__